import {Component, inject, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SessionDialogInput, SessionDialogOutput} from "@common/models/session-dialog";
import {AutomaticRecordingSessionDialogStore} from "./store/automatic-recording-session-dialog.store";
import {SimSessionService} from "@services";
import {Translations} from "@translations";

@Component({
	selector: "sim-automatic-recording-session-dialog",
	templateUrl: "./automatic-recording-session-dialog.component.html",
	styleUrl: "./automatic-recording-session-dialog.component.scss",
	providers: [AutomaticRecordingSessionDialogStore],
	standalone: false,
})
export class AutomaticRecordingSessionDialogComponent
	extends BasicMaterialDialog<AutomaticRecordingSessionDialogComponent, SessionDialogInput, SessionDialogOutput>
	implements OnInit
{
	public readonly T = Translations;

	readonly #sessionService = inject(SimSessionService);
	protected readonly store = inject(AutomaticRecordingSessionDialogStore);

	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.store.initializeStore(this.data.eventDay, this.data.eventId, this.data.sessionId);
	}

	protected async closeDialog() {
		const sessionId = this.store.session()?.id;
		if (sessionId) {
			const outputSession = await this.#sessionService.getSessionById(sessionId);
			this.dialogRef.close({action: "ok", outputSession});
		} else {
			this.dialogRef.close({action: "cancel"});
		}
	}
}
